var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',{attrs:{"type":"403","showBtn":false},on:{"error-click":_vm.handleLogout}})
}
var staticRenderFns = []

export { render, staticRenderFns }